import { Component, OnInit } from "@angular/core";
import {
  NavController,
  NavParams,
  ModalController,
  IonicModule,
} from "@ionic/angular";
import { EnqueteIniciarPage } from "./enquete-iniciar/enquete-iniciar.page";
import { EnquetePerguntasPage } from "./enquete-perguntas/enquete-perguntas.page";
import { EnqueteProvider } from "src/app/services/enquete/enquete";
import { EnqueteResultadoPage } from "./enquete-resultado/enquete-resultado.page";
import { Router } from "@angular/router";
import { CommonModule, Location } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { UserProvider } from "src/app/services/user/user";
import { TranslateModule } from "@ngx-translate/core";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { ImagePipe } from "src/app/pipes/image/image";
import { NomenclaturaPipe } from "src/app/pipes/nomenclatura/nomenclatura";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";

@Component({
  selector: "app-enquete-lista",
  templateUrl: "./enquete-lista.page.html",
  styleUrls: ["./enquete-lista.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    SemRegistroComponent,
    NomenclaturaPipe,
    LoadingSpinnerComponent,
  ],
})
export class EnqueteListaPage implements OnInit {
  enqueteList: any = [];
  respondidos: any = [];
  pendentes: any = [];
  loaded = false;
  currentUrl: boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public router: Router,
    private location: Location,
    public enqueteProvider: EnqueteProvider,
    public userProvider: UserProvider
  ) {
    const locationUrl = this.location.path();
    this.currentUrl = locationUrl === "/tabs/EnqueteListaPage" ? true : false;
    this.buscar();
  }

  ngOnInit() {}

  buscar() {
    this.enqueteProvider.getEnquetes().subscribe((data) => {
      this.enqueteList = data;
      this.respondidos = this.enqueteList.filter(
        (enquete: { status: number }) => enquete.status == 2
      );
      this.pendentes = this.enqueteList.filter(
        (enquete: { status: number }) => enquete.status == 1 || !enquete.status
      );
      this.loaded = true;
    });
  }

  async abrirEnquete(enquete: {
    status: any;
    id: any;
    descricao: string;
    perguntas: any;
    nomenclaturaBotaoProximo: string;
  }) {
    const data = {
      idEnquete: enquete.id,
      descricao: enquete.descricao,
      perguntasLength: enquete.perguntas,
      nomenclaturaBotaoProximo: enquete.nomenclaturaBotaoProximo,
    };

    let pageToOpen;

    switch (enquete.status) {
      case null:
        pageToOpen = EnqueteIniciarPage;
        break;
      case "1":
        pageToOpen = EnquetePerguntasPage;
        break;
      case "2":
        pageToOpen = EnqueteResultadoPage;
        break;
      default:
        break;
    }

    if (pageToOpen) {
      this.openModal(data, pageToOpen);
    }
  }

  private async abrirModalComRetorno(component: any, componentProps: any) {
    const modal = await this.modalCtrl.create({ component, componentProps });
    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data?.iniciar) {
      await this.abrirModalComRetorno(EnquetePerguntasPage, componentProps);
      return;
    }

    if (data?.acabou && data?.idEnquete) {
      this.buscar();

      const resultadoModal = await this.modalCtrl.create({
        component: EnqueteResultadoPage,
        componentProps: { idEnquete: data.idEnquete },
      });
      await resultadoModal.present();
      return;
    }

    this.buscar();
  }

  async openModal(data: any, component: any) {
    await this.abrirModalComRetorno(component, data);
  }

  async iniciar(data: any) {
    await this.abrirModalComRetorno(EnquetePerguntasPage, data);
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
